export default {
    init() {
        this.initTable();
        this.initModal();
        this.initProductAdd();
        this.initProductEdits();
        this.initProductDeletes();
    },
    initTable() {
        if ($('#product_table').length) {
            $('#product_table').ready(function () {
                $.ajax({
                    type: 'GET',
                    url: '/get_products',
                    success: function (response) {
                        $('#product_table').html(response);
                        $('#product_table #table').DataTable({
                            ajax: {
                                type: 'GET',
                                url: '/get_products_for_datatable',
                            },
                            columns: [
                                {'data': 'title'},
                                {
                                    'data': 'Category',
                                    render: function (data, type, row) {
                                        let title = '';
                                        if (row.categories != null) {
                                            title = row.categories.title;
                                        }
                                        return title;
                                    }
                                },
                                {
                                    'data': 'Modifier set',
                                    render: function (data, type, row) {
                                        return row.modifier_products.length;
                                    }
                                },
                                {'data': 'price'},
                                {
                                    'data': 'Action',
                                    render: function (data, type, row) {
                                        return '<div class="text-right">' +
                                            '<a href="#" class="btn text-secondary product-delete" data-id="' + row.id + '"><i class="fa fa-lg fa-trash"></i></a>' +
                                            '<a href="#" class="btn text-secondary product-edit" data-id="' + row.id + '"><i class="fa fa-lg fa-pencil"></i></a>' +
                                            '</div>';
                                    }
                                }
                            ],
                            "columnDefs": [{
                                "targets": 3,
                                "searchable": false,
                                "orderable": false
                            }]
                        });
                    }
                });
            });
        }
    },
    initModal() {
        $('.add-product').click(function () {
            $.ajax({
                type: 'GET',
                url: '/get_form_product',
                success: function (response) {
                    $('#product_form').html(response);
                    $('#product-modal').modal('show');
                },
                error: function (response) {
                    console.log(response);
                }
            })
        });
    },
    initProductAdd() {
        $('body').on('click', '#product-submit-form', function (e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/products',
                data: $('#product-form').serialize(),
                success: function () {
                    $('#product-modal').modal('hide');
                    $('#product_table #table').DataTable().ajax.reload(null, false);
                },
                error: function (response) {
                    let errorsHtml = '<div class="alert alert-danger">';
                    if (response.responseJSON.error) {
                        errorsHtml += response.responseJSON.error;
                    }
                    if (response.responseJSON.errors) {
                        errorsHtml += 'Some errors occurred:<br /><ul>';

                        $.each(response.responseJSON.errors, function (index, value) {
                            errorsHtml += '<li>' + value + '</li>';
                        });
                        errorsHtml += '</ul>';
                    }
                    errorsHtml += '</div>';
                    $('.product-form-wrapper .form-validation-errors').html(errorsHtml);
                }
            });
        });
    },
    initProductEdits() {
        $('body').on('click', '.product-edit', function (e) {
            e.preventDefault();
            $.ajax({
                type: 'GET',
                url: '/get_product',
                data: ({
                    id: $(this).data('id'),
                }),
                success: function (response) {
                    $('#product_form').html(response);
                    $('#product-modal').modal('show');
                },
                error: function (response) {
                    console.log(response);
                }
            });
        });
    },
    initProductDeletes() {
        $('body').on('click', '.product-delete', function () {
            if (confirm('You sure want to delete this?')) {
                $.ajax({
                    type: 'DELETE',
                    url: '/delete_product',
                    data: ({
                        id: $(this).data('id'),
                    }),
                    success: function () {
                        $('#product_table #table').DataTable().ajax.reload(null, false);
                    }
                });
            }
        })
    }
}
